import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { ModalComponent } from '@common/UI/modal/modal.component';
import { MailingService, MailRequest } from '@services/mailing.service';
import { Observable } from 'rxjs';

const regex: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function isEmailAddress(email: string): boolean {
  return regex.test(email.toLowerCase());
}

@Component({
  templateUrl: './mailing-popup.component.html',
  styleUrls: ['./mailing-popup.component.scss']
})
export class MailingPopupComponent implements OnInit {

  @Input()
  public title: string = 'Gửi email';
  @Input()
  public mailRequest: MailRequest = null;

  @ViewChild('modal')
  private modal: ModalComponent;

  private _loader = () => new Observable<boolean>(o => {
    if (!this._submitting) {
      o.next(true);
    }
    else {
      this.mailing.send(this.mailRequest).subscribe(succeed => {

        this._submitting = false;
        this._submitted = true;
        this._succeed = succeed;

        o.next(true);
      });
    }
  });

  private _last: string = '';
  private _error: string;
  private _submitted: boolean = false;
  private _submitting: boolean = false;
  private _succeed: boolean = false;

  public get loader() {
    return this._loader;
  }

  public get emails() {
    return this._last;
  }

  public get error() {
    return this._error;
  }

  public get submitted() {
    return this._submitted;
  }

  public get succeed() {
    return this._succeed;
  }

  public get submitable() {
    return this.mailRequest.Receivers.length > 0 || isEmailAddress(this._last);
  }

  constructor(private mailing: MailingService, public ms: ModalService) { }

  public ngOnInit() {
  }

  public update(event) {    

    let input: HTMLInputElement = event.target;    

    if (input.value.length > 0 && (event.keyCode == 13 || [' ', ';', ','].first(i => i == input.value[input.value.length - 1]))) {
      let norm: string[] = input.value.replace(/([\,; ])/g, ',').split(',').filter(i => i.length > 5);
      this.mailRequest.Receivers = this.mailRequest.Receivers.union(norm.filter(i => isEmailAddress(i))).distinct();
      let invalids = norm.filter(i => i.length > 0 && !isEmailAddress(i));

      this._error = invalids.length > 0 ? 'Địa chỉ: ' + invalids.join(', ') + ' không hợp lệ' : this.mailRequest.Receivers.length < 1 ? 'Chưa điền địa chỉ nhận thư' : null;

      if (!this._error) {
        input.value = '';
      }      
    }
    
    this._last = input.value;  
  }

  public remove(email: string) {
    this.mailRequest.Receivers = this.mailRequest.Receivers.filter(i => i != email);
  }

  public reset() {
    this._error = null;
  }

  public retry() {
    this._succeed = false;
    this._submitted = false;
    this.send();
  }

  public send() {

    if (!this._error) {

      if (isEmailAddress(this._last)) {
        this.mailRequest.Receivers = this.mailRequest.Receivers.union([this._last]).distinct();
      }

      this._submitting = true;
      this.modal.reload();
    }
  }

  public close() {
    this.modal.hide();
  }

}
